module.exports = require("react-toastify");